import { Empty } from "antd";
import Link from "next/link";
import * as React from "react";
import { useRouter } from "next/router";
type Props = { msg: any; children: any; hrefStr: any };

const Index = (props: Props) => {
    let { msg, children, hrefStr } = props;
    const router = useRouter();
    const { locale } = router;

    return (
        <div>
            <div className="w-full flex justify-center py-[150px] bg-[#ffffff] px-[15px] lg1024:!py-[50px] lg1024:!pt-[100px]">
                <div className="flex items-center left">
                    <Empty className="mx-auto w-[200px]"></Empty>
                </div>
                {/* <div className="right ml-[62px] lg1024:ml-[6px]">
                    <div
                        className="text-[48px] font-[600] text-[#2E384E] lg1024:!text-[20px]"
                        style={{
                            fontFamily: "PingFangSC-Semibold, PingFang SC",
                        }}
                    >
                        {msg}
                    </div>
                    <div
                        className="mt-[6px] text-[20px] font-[500] text-[#708096] lg1024:!text-[15px]"
                        style={{ fontFamily: "PingFangSC-Medium, PingFang SC" }}
                    >
                        {locale === "en"
                            ? "Ooops! Page No this Data~"
                            : "噢！没有此数据"}
                    </div>
                    <Link href={`/${locale}/${hrefStr}`}>
                        <div
                            className="mt-[30px] w-[112px] h-[40px] rounded-[4px] bg-[#FF3E5F] flex items-center justify-center text-[16px] font-[500] text-[#FFFFFF]"
                            style={{
                                fontFamily: "PingFangSC-Medium, PingFang SC",
                            }}
                        >
                            {locale === "en" ? "Go Back" : "返回"}
                        </div>
                    </Link>
                </div> */}
            </div>

            <div className="w-full bg-[#ffffff]">
                <div className="max-w-[1400px] my-0 mx-auto">
                    <div className="recommend ">{children}</div>
                </div>
            </div>
        </div>
    );
};

export default Index;
